export default function TS_Literal_Types() {
  return (
    <div>
      <h1>TS Literal Types</h1>
      <p>This is the TS Literal Types page.</p>
    </div>
  );
}